export const countriesList = [
  {
    name: 'Aruba',
    country_code: 'AW'
  },
  {
    name: 'Afghanistan',
    country_code: 'AF'
  },
  {
    name: 'Angola',
    country_code: 'AO'
  },
  {
    name: 'Anguilla',
    country_code: 'AI'
  },
  {
    name: '\u00c5land Islands',
    country_code: 'AX'
  },
  {
    name: 'Albania',
    country_code: 'AL'
  },
  {
    name: 'Andorra',
    country_code: 'AD'
  },
  {
    name: 'United Arab Emirates',
    country_code: 'AE'
  },
  {
    name: 'Argentina',
    country_code: 'AR'
  },
  {
    name: 'Armenia',
    country_code: 'AM'
  },
  {
    name: 'American Samoa',
    country_code: 'AS'
  },
  {
    name: 'Antigua and Barbuda',
    country_code: 'AG'
  },
  {
    name: 'Australia',
    country_code: 'AU'
  },
  {
    name: 'Austria',
    country_code: 'AT'
  },
  {
    name: 'Azerbaijan',
    country_code: 'AZ'
  },
  {
    name: 'Burundi',
    country_code: 'BI'
  },
  {
    name: 'Belgium',
    country_code: 'BE'
  },
  {
    name: 'Benin',
    country_code: 'BJ'
  },
  {
    name: 'Burkina Faso',
    country_code: 'BF'
  },
  {
    name: 'Bangladesh',
    country_code: 'BD'
  },
  {
    name: 'Bulgaria',
    country_code: 'BG'
  },
  {
    name: 'Bahrain',
    country_code: 'BH'
  },
  {
    name: 'Bahamas',
    country_code: 'BS'
  },
  {
    name: 'Bosnia and Herzegovina',
    country_code: 'BA'
  },
  {
    name: 'Saint Barth\u00e9lemy',
    country_code: 'BL'
  },
  {
    name: 'Belarus',
    country_code: 'BY'
  },
  {
    name: 'Belize',
    country_code: 'BZ'
  },
  {
    name: 'Bermuda',
    country_code: 'BM'
  },
  {
    name: 'Bolivia',
    country_code: 'BO'
  },
  {
    name: 'Brazil',
    country_code: 'BR'
  },
  {
    name: 'Barbados',
    country_code: 'BB'
  },
  {
    name: 'Brunei',
    country_code: 'BN'
  },
  {
    name: 'Bhutan',
    country_code: 'BT'
  },
  {
    name: 'Botswana',
    country_code: 'BW'
  },
  {
    name: 'Central African Republic',
    country_code: 'CF'
  },
  {
    name: 'Canada',
    country_code: 'CA'
  },
  {
    name: 'Cocos (Keeling) Islands',
    country_code: 'CC'
  },
  {
    name: 'Switzerland',
    country_code: 'CH'
  },
  {
    name: 'Chile',
    country_code: 'CL'
  },
  {
    name: 'China',
    country_code: 'CN'
  },
  {
    name: 'Ivory Coast',
    country_code: 'CI'
  },
  {
    name: 'Cameroon',
    country_code: 'CM'
  },
  {
    name: 'DR Congo',
    country_code: 'CD'
  },
  {
    name: 'Republic of the Congo',
    country_code: 'CG'
  },
  {
    name: 'Cook Islands',
    country_code: 'CK'
  },
  {
    name: 'Colombia',
    country_code: 'CO'
  },
  {
    name: 'Comoros',
    country_code: 'KM'
  },
  {
    name: 'Cape Verde',
    country_code: 'CV'
  },
  {
    name: 'Costa Rica',
    country_code: 'CR'
  },
  {
    name: 'Cuba',
    country_code: 'CU'
  },
  {
    name: 'Cura\u00e7ao',
    country_code: 'CW'
  },
  {
    name: 'Christmas Island',
    country_code: 'CX'
  },
  {
    name: 'Cayman Islands',
    country_code: 'KY'
  },
  {
    name: 'Cyprus',
    country_code: 'CY'
  },
  {
    name: 'Czech Republic',
    country_code: 'CZ'
  },
  {
    name: 'Germany',
    country_code: 'DE'
  },
  {
    name: 'Djibouti',
    country_code: 'DJ'
  },
  {
    name: 'Dominica',
    country_code: 'DM'
  },
  {
    name: 'Denmark',
    country_code: 'DK'
  },
  {
    name: 'Dominican Republic',
    country_code: 'DO'
  },
  {
    name: 'Algeria',
    country_code: 'DZ'
  },
  {
    name: 'Ecuador',
    country_code: 'EC'
  },
  {
    name: 'Egypt',
    country_code: 'EG'
  },
  {
    name: 'Eritrea',
    country_code: 'ER'
  },
  {
    name: 'Western Sahara',
    country_code: 'EH'
  },
  {
    name: 'Spain',
    country_code: 'ES'
  },
  {
    name: 'Estonia',
    country_code: 'EE'
  },
  {
    name: 'Ethiopia',
    country_code: 'ET'
  },
  {
    name: 'Finland',
    country_code: 'FI'
  },
  {
    name: 'Fiji',
    country_code: 'FJ'
  },
  {
    name: 'Falkland Islands',
    country_code: 'FK'
  },
  {
    name: 'France',
    country_code: 'FR'
  },
  {
    name: 'Faroe Islands',
    country_code: 'FO'
  },
  {
    name: 'Micronesia',
    country_code: 'FM'
  },
  {
    name: 'Gabon',
    country_code: 'GA'
  },
  {
    name: 'United Kingdom',
    country_code: 'GB'
  },
  {
    name: 'Georgia',
    country_code: 'GE'
  },
  {
    name: 'Guernsey',
    country_code: 'GG'
  },
  {
    name: 'Ghana',
    country_code: 'GH'
  },
  {
    name: 'Gibraltar',
    country_code: 'GI'
  },
  {
    name: 'Guinea',
    country_code: 'GN'
  },
  {
    name: 'Gambia',
    country_code: 'GM'
  },
  {
    name: 'Guinea-Bissau',
    country_code: 'GW'
  },
  {
    name: 'Equatorial Guinea',
    country_code: 'GQ'
  },
  {
    name: 'Greece',
    country_code: 'GR'
  },
  {
    name: 'Grenada',
    country_code: 'GD'
  },
  {
    name: 'Greenland',
    country_code: 'GL'
  },
  {
    name: 'Guatemala',
    country_code: 'GT'
  },
  {
    name: 'Guam',
    country_code: 'GU'
  },
  {
    name: 'Guyana',
    country_code: 'GY'
  },
  {
    name: 'Hong Kong',
    country_code: 'HK'
  },
  {
    name: 'Honduras',
    country_code: 'HN'
  },
  {
    name: 'Croatia',
    country_code: 'HR'
  },
  {
    name: 'Haiti',
    country_code: 'HT'
  },
  {
    name: 'Hungary',
    country_code: 'HU'
  },
  {
    name: 'Indonesia',
    country_code: 'ID'
  },
  {
    name: 'Isle of Man',
    country_code: 'IM'
  },
  {
    name: 'India',
    country_code: 'IN'
  },
  {
    name: 'British Indian Ocean Territory',
    country_code: 'IO'
  },
  {
    name: 'Ireland',
    country_code: 'IE'
  },
  {
    name: 'Iran',
    country_code: 'IR'
  },
  {
    name: 'Iraq',
    country_code: 'IQ'
  },
  {
    name: 'Iceland',
    country_code: 'IS'
  },
  {
    name: 'Israel',
    country_code: 'IL'
  },
  {
    name: 'Italy',
    country_code: 'IT'
  },
  {
    name: 'Jamaica',
    country_code: 'JM'
  },
  {
    name: 'Jersey',
    country_code: 'JE'
  },
  {
    name: 'Jordan',
    country_code: 'JO'
  },
  {
    name: 'Japan',
    country_code: 'JP'
  },
  {
    name: 'Kazakhstan',
    country_code: 'KZ'
  },
  {
    name: 'Kenya',
    country_code: 'KE'
  },
  {
    name: 'Kyrgyzstan',
    country_code: 'KG'
  },
  {
    name: 'Cambodia',
    country_code: 'KH'
  },
  {
    name: 'Kiribati',
    country_code: 'KI'
  },
  {
    name: 'Saint Kitts and Nevis',
    country_code: 'KN'
  },
  {
    name: 'South Korea',
    country_code: 'KR'
  },
  {
    name: 'Kosovo',
    country_code: 'XK'
  },
  {
    name: 'Kuwait',
    country_code: 'KW'
  },
  {
    name: 'Laos',
    country_code: 'LA'
  },
  {
    name: 'Lebanon',
    country_code: 'LB'
  },
  {
    name: 'Liberia',
    country_code: 'LR'
  },
  {
    name: 'Libya',
    country_code: 'LY'
  },
  {
    name: 'Saint Lucia',
    country_code: 'LC'
  },
  {
    name: 'Liechtenstein',
    country_code: 'LI'
  },
  {
    name: 'Sri Lanka',
    country_code: 'LK'
  },
  {
    name: 'Lesotho',
    country_code: 'LS'
  },
  {
    name: 'Lithuania',
    country_code: 'LT'
  },
  {
    name: 'Luxembourg',
    country_code: 'LU'
  },
  {
    name: 'Latvia',
    country_code: 'LV'
  },
  {
    name: 'Macau',
    country_code: 'MO'
  },
  {
    name: 'Morocco',
    country_code: 'MA'
  },
  {
    name: 'Monaco',
    country_code: 'MC'
  },
  {
    name: 'Moldova',
    country_code: 'MD'
  },
  {
    name: 'Madagascar',
    country_code: 'MG'
  },
  {
    name: 'Maldives',
    country_code: 'MV'
  },
  {
    name: 'Mexico',
    country_code: 'MX'
  },
  {
    name: 'Marshall Islands',
    country_code: 'MH'
  },
  {
    name: 'Macedonia',
    country_code: 'MK'
  },
  {
    name: 'Mali',
    country_code: 'ML'
  },
  {
    name: 'Malta',
    country_code: 'MT'
  },
  {
    name: 'Myanmar',
    country_code: 'MM'
  },
  {
    name: 'Montenegro',
    country_code: 'ME'
  },
  {
    name: 'Mongolia',
    country_code: 'MN'
  },
  {
    name: 'Northern Mariana Islands',
    country_code: 'MP'
  },
  {
    name: 'Mozambique',
    country_code: 'MZ'
  },
  {
    name: 'Mauritania',
    country_code: 'MR'
  },
  {
    name: 'Montserrat',
    country_code: 'MS'
  },
  {
    name: 'Martinique',
    country_code: 'MQ'
  },
  {
    name: 'Mauritius',
    country_code: 'MU'
  },
  {
    name: 'Malawi',
    country_code: 'MW'
  },
  {
    name: 'Malaysia',
    country_code: 'MY'
  },
  {
    name: 'Namibia',
    country_code: 'NA'
  },
  {
    name: 'Niger',
    country_code: 'NE'
  },
  {
    name: 'Norfolk Island',
    country_code: 'NF'
  },
  {
    name: 'Nigeria',
    country_code: 'NG'
  },
  {
    name: 'Nicaragua',
    country_code: 'NI'
  },
  {
    name: 'Niue',
    country_code: 'NU'
  },
  {
    name: 'Netherlands',
    country_code: 'NL'
  },
  {
    name: 'Norway',
    country_code: 'NO'
  },
  {
    name: 'Nepal',
    country_code: 'NP'
  },
  {
    name: 'Nauru',
    country_code: 'NR'
  },
  {
    name: 'New Zealand',
    country_code: 'NZ'
  },
  {
    name: 'Oman',
    country_code: 'OM'
  },
  {
    name: 'Pakistan',
    country_code: 'PK'
  },
  {
    name: 'Panama',
    country_code: 'PA'
  },
  {
    name: 'Pitcairn Islands',
    country_code: 'PN'
  },
  {
    name: 'Peru',
    country_code: 'PE'
  },
  {
    name: 'Philippines',
    country_code: 'PH'
  },
  {
    name: 'Palau',
    country_code: 'PW'
  },
  {
    name: 'Papua New Guinea',
    country_code: 'PG'
  },
  {
    name: 'Poland',
    country_code: 'PL'
  },
  {
    name: 'Puerto Rico',
    country_code: 'PR'
  },
  {
    name: 'North Korea',
    country_code: 'KP'
  },
  {
    name: 'Portugal',
    country_code: 'PT'
  },
  {
    name: 'Paraguay',
    country_code: 'PY'
  },
  {
    name: 'French Polynesia',
    country_code: 'PF'
  },
  {
    name: 'Qatar',
    country_code: 'QA'
  },
  {
    name: 'Romania',
    country_code: 'RO'
  },
  {
    name: 'Russia',
    country_code: 'RU'
  },
  {
    name: 'Rwanda',
    country_code: 'RW'
  },
  {
    name: 'Saudi Arabia',
    country_code: 'SA'
  },
  {
    name: 'Sudan',
    country_code: 'SD'
  },
  {
    name: 'Senegal',
    country_code: 'SN'
  },
  {
    name: 'Singapore',
    country_code: 'SG'
  },
  {
    name: 'Solomon Islands',
    country_code: 'SB'
  },
  {
    name: 'Sierra Leone',
    country_code: 'SL'
  },
  {
    name: 'El Salvador',
    country_code: 'SV'
  },
  {
    name: 'San Marino',
    country_code: 'SM'
  },
  {
    name: 'Somalia',
    country_code: 'SO'
  },
  {
    name: 'Serbia',
    country_code: 'RS'
  },
  {
    name: 'South Sudan',
    country_code: 'SS'
  },
  {
    name: 'S\u00e3o Tom\u00e9 and Pr\u00edncipe',
    country_code: 'ST'
  },
  {
    name: 'Suriname',
    country_code: 'SR'
  },
  {
    name: 'Slovakia',
    country_code: 'SK'
  },
  {
    name: 'Slovenia',
    country_code: 'SI'
  },
  {
    name: 'Sweden',
    country_code: 'SE'
  },
  {
    name: 'Swaziland',
    country_code: 'SZ'
  },
  {
    name: 'Sint Maarten',
    country_code: 'SX'
  },
  {
    name: 'Seychelles',
    country_code: 'SC'
  },
  {
    name: 'Syria',
    country_code: 'SY'
  },
  {
    name: 'Turks and Caicos Islands',
    country_code: 'TC'
  },
  {
    name: 'Chad',
    country_code: 'TD'
  },
  {
    name: 'Togo',
    country_code: 'TG'
  },
  {
    name: 'Thailand',
    country_code: 'TH'
  },
  {
    name: 'Tajikistan',
    country_code: 'TJ'
  },
  {
    name: 'Tokelau',
    country_code: 'TK'
  },
  {
    name: 'Turkmenistan',
    country_code: 'TM'
  },
  {
    name: 'Timor-Leste',
    country_code: 'TL'
  },
  {
    name: 'Tonga',
    country_code: 'TO'
  },
  {
    name: 'Trinidad and Tobago',
    country_code: 'TT'
  },
  {
    name: 'Tunisia',
    country_code: 'TN'
  },
  {
    name: 'Turkey',
    country_code: 'TR'
  },
  {
    name: 'Tuvalu',
    country_code: 'TV'
  },
  {
    name: 'Taiwan',
    country_code: 'TW'
  },
  {
    name: 'Tanzania',
    country_code: 'TZ'
  },
  {
    name: 'Uganda',
    country_code: 'UG'
  },
  {
    name: 'Ukraine',
    country_code: 'UA'
  },
  {
    name: 'Uruguay',
    country_code: 'UY'
  },
  {
    name: 'United States',
    country_code: 'US'
  },
  {
    name: 'Uzbekistan',
    country_code: 'UZ'
  },
  {
    name: 'Vatican City',
    country_code: 'VA'
  },
  {
    name: 'Saint Vincent and the Grenadines',
    country_code: 'VC'
  },
  {
    name: 'Venezuela',
    country_code: 'VE'
  },
  {
    name: 'British Virgin Islands',
    country_code: 'VG'
  },
  {
    name: 'United States Virgin Islands',
    country_code: 'VI'
  },
  {
    name: 'Vietnam',
    country_code: 'VN'
  },
  {
    name: 'Vanuatu',
    country_code: 'VU'
  },
  {
    name: 'Samoa',
    country_code: 'WS'
  },
  {
    name: 'Yemen',
    country_code: 'YE'
  },
  {
    name: 'South Africa',
    country_code: 'ZA'
  },
  {
    name: 'Zambia',
    country_code: 'ZM'
  },
  {
    name: 'Zimbabwe',
    country_code: 'ZW'
  },
  {
    name: 'Alabama',
    country_code: 'US-AL'
  },
  {
    name: 'Alaska',
    country_code: 'US-AK'
  },
  {
    name: 'Arizona',
    country_code: 'US-AZ'
  },
  {
    name: 'Arkansas',
    country_code: 'US-AR'
  },
  {
    name: 'California',
    country_code: 'US-CA'
  },
  {
    name: 'Colorado',
    country_code: 'US-CO'
  },
  {
    name: 'Connecticut',
    country_code: 'US-CT'
  },
  {
    name: 'Delaware',
    country_code: 'US-DE'
  },
  {
    name: 'Florida',
    country_code: 'US-FL'
  },
  {
    name: 'Georgia',
    country_code: 'US-GA'
  },
  {
    name: 'Hawaii',
    country_code: 'US-HI'
  },
  {
    name: 'Idaho',
    country_code: 'US-ID'
  },
  {
    name: 'Illinois',
    country_code: 'US-IL'
  },
  {
    name: 'Indiana',
    country_code: 'US-IN'
  },
  {
    name: 'Iowa',
    country_code: 'US-IA'
  },
  {
    name: 'Kansas',
    country_code: 'US-KS'
  },
  {
    name: 'Kentucky',
    country_code: 'US-KY'
  },
  {
    name: 'Louisiana',
    country_code: 'US-LA'
  },
  {
    name: 'Maine',
    country_code: 'US-ME'
  },
  {
    name: 'Maryland',
    country_code: 'US-MD'
  },
  {
    name: 'Massachusetts',
    country_code: 'US-MA'
  },
  {
    name: 'Michigan',
    country_code: 'US-MI'
  },
  {
    name: 'Minnesota',
    country_code: 'US-MN'
  },
  {
    name: 'Mississippi',
    country_code: 'US-MS'
  },
  {
    name: 'Missouri',
    country_code: 'US-MO'
  },
  {
    name: 'Montana',
    country_code: 'US-MT'
  },
  {
    name: 'Nebraska',
    country_code: 'US-NE'
  },
  {
    name: 'Nevada',
    country_code: 'US-NV'
  },
  {
    name: 'New Hampshire',
    country_code: 'US-NH'
  },
  {
    name: 'New Jersey',
    country_code: 'US-NJ'
  },
  {
    name: 'New Mexico',
    country_code: 'US-NM'
  },
  {
    name: 'New York',
    country_code: 'US-NY'
  },
  {
    name: 'North Carolina',
    country_code: 'US-NC'
  },
  {
    name: 'North Dakota',
    country_code: 'US-ND'
  },
  {
    name: 'Ohio',
    country_code: 'US-OH'
  },
  {
    name: 'Oklahoma',
    country_code: 'US-OK'
  },
  {
    name: 'Oregon',
    country_code: 'US-OR'
  },
  {
    name: 'Pennsylvania',
    country_code: 'US-PA'
  },
  {
    name: 'Rhode Island',
    country_code: 'US-RI'
  },
  {
    name: 'South Carolina',
    country_code: 'US-SC'
  },
  {
    name: 'South Dakota',
    country_code: 'US-SD'
  },
  {
    name: 'Tennessee',
    country_code: 'US-TN'
  },
  {
    name: 'Texas',
    country_code: 'US-TX'
  },
  {
    name: 'Utah',
    country_code: 'US-UT'
  },
  {
    name: 'Vermont',
    country_code: 'US-VT'
  },
  {
    name: 'Virginia',
    country_code: 'US-VA'
  },
  {
    name: 'Washington',
    country_code: 'US-WA'
  },
  {
    name: 'West Virginia',
    country_code: 'US-WV'
  },
  {
    name: 'Wisconsin',
    country_code: 'US-WI'
  },
  {
    name: 'Wyoming',
    country_code: 'US-WY'
  },
  {
    name: 'American Samoa',
    country_code: 'US-AS'
  },
  {
    name: 'District of Columbia',
    country_code: 'US-DC'
  },
  {
    name: 'Guam',
    country_code: 'US-GU'
  },
  {
    name: 'Northern Mariana Islands',
    country_code: 'US-MP'
  },
  {
    name: 'Puerto Rico',
    country_code: 'US-PR'
  },
  {
    name: 'United States Virgin Islands',
    country_code: 'US-VI'
  }
];
